export default "__VITE_ASSET__C1DcPoo1__"